<template>
    <div class="bg-white has-shadow p-3 p-xl-5">
        <h4 class="mb-4">Room {{value.leg}}:</h4>
        <span>{{names}}</span>



        <div v-if="value.rate.rateGroupRate.IncludesSpaPool" class="row itinerary-item p-4 itinerary-item--spa-pool">
            <div class="col-24 col-sm-21 offset-sm-3">
                <span class="intinerary-label">Pool &amp; Spa Access </span>
                <button v-on:click="showSpaPoolModal(room)" class="btn btn--slate-blue btn--block btn--add">
                    BOOK YOUR TIME
                </button>
            </div>
        </div>

        <div v-if="value.rate.rateGroupRate.IncludesSpa" class="row itinerary-item p-4 itinerary-item--spa-package">
            <div class="col-24 col-sm-21 offset-sm-3">

                <span class="intinerary-label">Spa Package Extras</span>


                <div v-if="spaStatus != null" v-html="spaStatus.InlineMessage">

                </div>

                <div v-else>

                    <div v-if="legSpa" class="itinerary-selection">
                        <div class="itinerary-selection-detail">
                            <button v-on:click="resetSpaPackage(value)"
                                    class="itinerary-selection-reset">
                                Reset
                            </button>
                            <ul >
                                <li class="mb-2"
                                    v-for="(item, index) in legSpa"
                                    v-bind:key="index">

                                    <strong>
                                        {{item.guestName}}: {{item.treatmentName}} - {{item.treatmentDuration}}
                                    </strong>
                                       {{item.treatmentDateTime}}
                        
                                </li>
                            </ul>


                            
                        </div>
                    </div>
                    <div v-else>
                        <button v-on:click="showSpaPackageModal(room)" class="btn btn--slate-blue btn--block btn--add">

                            BOOK YOUR TREATMENTS
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!value.rate.rateGroupRate.IncludesBreakfast && !value.rate.rateGroupRate.IncludesDinner" class="row itinerary-item p-4 itinerary-item--breakfast">
            <div class="col-24 col-sm-21 offset-sm-3">
                <span class="intinerary-label">Breakfast Times</span>



                <div class="itinerary-selection">

                    <div class="itinerary-selection-detail">

                        <ul>
                            <li>
                                <span>
                                    Breakfast is not included in your self-catering rate.
                                </span>


                            </li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>

        <div v-if="!value.rate.rateGroupRate.IncludesBreakfast && !value.rate.rateGroupRate.IncludesDinner" class="row itinerary-item p-4 itinerary-item--breakfast">
            <div class="col-24 col-sm-21 offset-sm-3">
                <span class="intinerary-label">Dinner Times</span>

                <div class="itinerary-selection">

                    <div class="itinerary-selection-detail">

                        <ul>
                            <li>
                                <span>

                                    Dinner is not included in your self-catering rate however you can choose to add on dinner at The Orangery, Clubhouse or Nu Sana on the next screen.
                                </span>


                            </li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>



        <div v-if="value.rate.rateGroupRate.IncludesBreakfast" class="row itinerary-item p-4 itinerary-item--breakfast">
            <div class="col-24 col-sm-21 offset-sm-3">
                <span class="intinerary-label">Breakfast Times</span>


                <div v-if="restaurantStatus != null" v-html="restaurantStatus.InlineMessage">

                </div>

                <div v-else>


                    <p>Please reserve your breakfast times below. We strongly advise booking today to avoid disappointment.</p>

                    <!--<div class="row mt-3 mb-3">
                        <div class="col-24 col-xl-12 mb-2 mb-xl-0">
                            <label class="restaurant-time">

                                <input type="radio" v-model="breakfastLater" v-bind:value="true" v-on:click="resetBreakfast(value)" />
                                <span>Decide Later</span>
                            </label>
                        </div>
                        <div class="col-24 col-xl-12">

                            <label class="restaurant-time">

                                <input type="radio" v-model="breakfastLater" v-bind:value="false" />
                                <span>Decide Now</span>
                            </label>
                        </div>
                    </div>-->

                    <div>


                        <div v-if="!value.breakfast">
                            <button 
                                    class="btn btn--slate-blue btn--block btn--add"
                                    v-on:click="showBreakfastModal(room)">
                                Book your tables
                            </button>


                            <p class="mt-2">You can still book your tables later</p>
                        </div>


                        <div v-if="value.breakfast">
                            <div class="itinerary-selection">

                                <div class="itinerary-selection-detail">
                                    <button v-on:click="resetBreakfast(value)"
                                            class="itinerary-selection-reset">
                                        Reset
                                    </button>
                                    <ul v-if="value.breakfast.filter(item => item.isAvailable).length">
                                        <li v-for="(breakfast, index) in value.breakfast.filter(item => item.isAvailable)"
                                            v-bind:key="index">
                                            <strong>
                                                {{formatShortDate(breakfast.date)}}:
                                            </strong>
                                            <span class="d-block d-xl-inline">

                                                {{getBreakfastRestaurantName(breakfast.restaurant)}} - {{formatTime(breakfast.timeslot)}}
                                            </span>
                                        </li>
                                    </ul>
                                    <div v-if="!value.breakfast.filter(item => item.isAvailable).length">
                                        <p>Unfortunately at present there is no availability for your selected dates. Please complete your preferred dining times in the comments box on the Guest Details screen and the team will be in touch to confirm.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div v-if="value.rate.rateGroupRate.IncludesDinner" class="row itinerary-item p-4 itinerary-item--dinner">
            <div class="col-24 col-sm-21 offset-sm-3">
                <span class="intinerary-label">Dinner Times</span>

                <div v-if="restaurantStatus != null" v-html="restaurantStatus.InlineMessage">

                </div>

                <div v-else>

                 


                    <div>
                        <div  v-if="!value.dinner">
                            <button
                                    class="btn btn--slate-blue btn--block btn--add"
                                    v-on:click="showDinnerModal(room)">
                                Book your tables
                            </button>


                            <p class="mt-2">You can still book your tables later</p>
                        </div>
                        <div v-if="value.dinner">
                            <div class="itinerary-selection">

                                <div class="itinerary-selection-detail">
                                    <button v-on:click="resetDinner(value)"
                                            class="itinerary-selection-reset">
                                        Reset
                                    </button>

                                    <ul v-if="value.dinner.filter(item => item.isAvailable).length">
                                        <li v-for="(dinner, index) in value.dinner.filter(item => item.isAvailable)"
                                            v-bind:key="index">

                                            <strong>
                                                {{formatShortDate(dinner.date)}}:
                                            </strong>

                                            {{getDinnerRestaurantName(dinner.restaurant)}} - {{formatTime(dinner.timeslot)}}
                                        </li>
                                    </ul>
                                    <div v-if="!value.dinner.filter(item => item.isAvailable).length">
                                        <p>Unfortunately at present there is no availability for your selected dates. Please complete your preferred dining times in the comments box on the Guest Details screen and the team will be in touch to confirm.</p>
                                    </div>
                                </div>
                            </div>

                        </div>


                    </div>
                </div>
            </div>
        </div>



    </div>




    <booking-modal v-if="modalGolfVisible" v-on:close="modalGolfVisible = false">
        <template v-slot:logo>
            <img src="/Assets/img/booking/flag-gold.svg" />
        </template>
        <template v-slot:header>
            Golf Package
        </template>
        <template v-slot:body>
            <golf-availability v-bind:room="value"></golf-availability>
        </template>

    </booking-modal>

    <booking-modal v-bind:isFull="true" v-if="modalSpaPackageVisible" v-on:close="modalSpaPackageVisible = false">
        <template v-slot:logo>
            <img src="/Assets/img/booking/spa_package-gold.svg" />
        </template>
        <template v-slot:header>
            <span v-if="booking.legs.length > 1">Room {{value.leg}}: </span>  Spa Package
        </template>
        <template v-slot:body>
            <spa-package-availability v-bind:room="value"></spa-package-availability>
        </template>
    </booking-modal>


    <booking-modal v-if="modalSpaPoolVisible" v-on:close="modalSpaPoolVisible = false">
        <template v-slot:logo>
            <img src="/Assets/img/booking/spa_pool-gold.svg" />
        </template>
        <template v-slot:header>
            Spa Pool
        </template>
        <template v-slot:body>
            <spa-pool-availability v-bind:leg="value.leg"></spa-pool-availability>
        </template>
    </booking-modal>

    <booking-modal v-if="modalBreakfastVisible" v-on:close="modalBreakfastVisible = false">
        <template v-slot:logo>
            <img src="/Assets/img/booking/breakfast-gold.svg" />
        </template>
        <template v-slot:header>
            <span v-if="booking.legs.length > 1">Room {{value.leg}}: </span>Breakfast times
        </template>
        <template v-slot:body>
            <breakfast-availability v-bind:occupancy="guestCount"
                                    v-bind:value="value"></breakfast-availability>
        </template>



    </booking-modal>

    <booking-modal v-if="modalDinnerVisible" v-on:close="modalDinnerVisible = false">
        <template v-slot:logo>
            <img src="/Assets/img/booking/dinner-gold.svg" />
        </template>
        <template v-slot:header>
            <span v-if="booking.legs.length > 1">Room {{value.leg}}: </span>Dinner times
        </template>
        <template v-slot:body>
            <dinner-availability v-bind:occupancy="guestCount"
                                 v-bind:value="value"></dinner-availability>
        </template>
    </booking-modal>






</template>

<script>
    import moment from 'moment';

    import { store } from '../store/index';

    import BookingModal from './BookingModal.vue';

    import GolfAvailability from './GolfAvailability.vue';
    import DinnerAvailability from './DinnerAvailability.vue';
    import BreakfastAvailability from './BreakfastAvailability.vue';
    import SpaPoolAvailability from './SpaPoolAvailability.vue';
    import SpaPackageAvailability from './SpaPackageAvailability.vue';

    import { _ } from 'vue-underscore';

    export default {
        name: 'ItineraryOptions',
        props: {
            value: {
                type: Object,
                required: true
            }
        },
        computed: {
            spaConfiguration() {
                return this.getters.spaConfiguration;
            },
            names() {

                var result = '';
                for (var i = 0; i < this.value.guests.length; i++) {
                    let guest = this.value.guests[i];

                    result += guest.firstName + ' ' + guest.lastName;

                    if (this.value.guests.length > i + 1) {
                        result += ', ';
                    }

                }

                return result;
            },
            guestCount() {
                return this.value.guestQuota.Adults + this.value.guestQuota.Children;
            },
            booking() {
                return store.getters.booking;
            },
            golfStatus() {
                let status = store.getters.golfSystemStatus;
                if (status != null && status.IsDisabled) {
                    return status;
                }
                return null;
            },
            restaurantStatus() {
                let status = store.getters.restaurantSystemStatus;
                if (status != null && status.IsDisabled) {
                    return status;
                }
                return null;
            },
            spaStatus() {
                let status = store.getters.spaSystemStatus;
                if (status != null && status.IsDisabled) {
                    return status;
                }
                return null;
            },
            legSpa() {

                let spaPackages = this.value?.spaPackages;
                
                if (spaPackages != null) {
                    let result = [];
                    
                    let ordered = _.sortBy(spaPackages, function (item) {  return moment(item.time.StartTime).unix(); });
                    for (let spi = 0; spi < ordered.length; spi++) {
   
                        var item = ordered[spi];
                        result.push({
                            guestName: this.value.guests[item.guestIndex].firstName,
                            treatmentName: item.treatment.DisplayName,
                            treatmentDuration: item.duration.Duration + 'mins',
                            treatmentDateTime: moment(item.time.StartTime).format('ddd Do MMM YY - h:mma')
                        })
                    }

                    return result;
                };
                return null;
            }
        },
        components: {
            BookingModal,

            GolfAvailability,
            DinnerAvailability,
            BreakfastAvailability,
            SpaPoolAvailability,
            SpaPackageAvailability
        },
        data() {
            return {
                //breakfastLater: true,
                //dinnerLater: true,
                modalGolfVisible: false,
                modalSpaPackageVisible: false,
                modalSpaPoolVisible: false,
                modalBreakfastVisible: false,
                modalDinnerVisible: false,
            }
        },
        methods: {
            getBreakfastRestaurantName(input) {
                return this.value.rate.rateGroupRate.BreakfastRestaurants.find(item => item.RestaurantId == input).DisplayName;
            },
            getDinnerRestaurantName(input) {
                return this.value.rate.rateGroupRate.DinnerRestaurants.find(item => item.RestaurantId == input).DisplayName;
            },
            showGolfModal() {
                this.modalGolfVisible = true;
            },
            resetGolf(room) {
                var payload = {
                    leg: room.leg,
                    selection: null
                }

                store.dispatch("selectGolf", payload);

                //this.modalGolfVisible = true;
            },
            resetSpaPackage(room) {
                var payload = {
                    leg: room.leg,
                    selection: null
                }

                store.dispatch("attachSpaPackage", payload);

            },
            resetDinner(room) {
                var payload = {
                    leg: room.leg,
                    restaurantBookings: null
                }

                store.dispatch("selectDinner", payload);

            },
            resetBreakfast(room) {
                var payload = {
                    leg: room.leg,
                    restaurantBookings: null
                }

                store.dispatch("selectBreakfast", payload);

            },
            showSpaPackageModal() {
                this.modalSpaPackageVisible = true;
            },
            showSpaPoolModal() {
                this.modalSpaPoolVisible = true;
            },
            showBreakfastModal() {
                this.modalBreakfastVisible = true;
            },
            showDinnerModal() {
                this.modalDinnerVisible = true;
            },
            formatLongDateTime(input) {
                var date = moment(input);
                return date.format('ddd Do MMM - HH:mm')
            },
            formatShortDate(input) {
                var date = moment(input);
                return date.format('dddd')
            },
            formatTime(input) {
                var date = moment(input);
                return date.format('HH:mm')
            }
        }
    }
</script>

<style scoped>
    .itinerary-selection {
        padding: 20px;
        border-radius: 2px;
        background-color: #eae5e3;
        color: #333;
        font-size: 14px;
        font-family: Montserrat;
        position: relative;
    }



    .itinerary-selection-reset {
        text-indent: -9999px;
        position: absolute;
        top: 20px;
        right: 20px;
        border: none;
        height: 15px;
        width: 15px;
        background-size: 15px 15px;
        background-position: center center;
        background-repeat: no-repeat;
        background-image: url(/Assets/img/website/modal-close.svg);
        background-color: transparent;
    }


    .itinerary-selection-title {
        font-weight: bold;
    }

    .itinerary-selection-detail {
        font-weight: 300;
    }

    .itinerary-selection ul {
        list-style: none;
        padding: 0;
        margin-bottom: 0;
    }


    .restaurant-time {
        font-size: 14px;
        text-transform: none;
        font-weight: 300;
        position: relative;
        cursor: pointer;
    }

        .restaurant-time span {
            position: relative;
            display: block;
            padding-left: 32px;
        }

            .restaurant-time span:before {
                width: 22px;
                height: 22px;
                position: absolute;
                border-radius: 50%;
                background: white;
                border: solid 1px #666;
                content: ' ';
                left: 0px;
                display: block;
            }

        .restaurant-time input {
            display: none;
        }




            .restaurant-time input:checked + span:after {
                width: 14px;
                height: 14px;
                position: absolute;
                border-radius: 50%;
                background: #425260;
                left: 4px;
                top: 4px;
                content: ' ';
                display: block;
            }

    @media(min-width: 1200px) {
        .restaurant-time {
            font-size: 16px;
        }
    }
</style>